<template>
  <page icon="coins" :title="`New ${Naming.JobType}`" v-bind="{ loading }">
    <form class="box">
      <div class="columns is-multiline">
        <div class="column is-6">
          <text-input
              placeholder="ex: Repair, Survey, etc…"
              required
              :error="$root.errors.description"
              :value="jobType.description"
              @input="description">
            Description
          </text-input>
        </div>
        <div class="column is-6">
          <number-input
              :precision="0"
              :min="50"
              :max="100"
              required
              :error="$root.errors.pass_percentage"
              :value="jobType.pass_percentage"
              @input="passPercentage">
            Pass Percentage
          </number-input>
        </div>
        <div class="column is-6">
          <switch-input
              :description="`${Naming.JobTypes} that are not active will not be available on ${Naming.Jobs.toLowerCase()}`"
              classes="is-medium"
              @input="toggleActive"
              :value="jobType.active">
            Active {{ Naming.JobType }}
          </switch-input>
        </div>
        <div class="column is-6">
          <switch-input
              :description="`When required, ${Naming.Jobs.toLowerCase()} of this type will require the customer to provide their name as well as a signature before closing it off.`"
              classes="is-medium"
              @input="toggleSignatureRequirement"
              :value="jobType.requires_signature">
            Requires a Signature
          </switch-input>
        </div>
        <div class="column is-6">
          <switch-input
              :description="`${Naming.Jobs} which carry this ${Naming.JobType.toLowerCase()} will be limited to 1 ${Naming.Inspection.toLowerCase()} per ${Naming.Job.toLowerCase()}.`"
              classes="is-medium"
              @input="toggleSingleInspection"
              :value="jobType.single_inspection">
            Limit {{ Naming.Jobs }} to 1 {{ Naming.Inspection.toLowerCase() }} per {{ Naming.Job.toLowerCase() }}.
          </switch-input>
        </div>
        <div class="column is-6">
          <switch-input
              :description="`Display map (if available) on the ${Naming.Inspection.toLowerCase()} report PDF.`"
              classes="is-medium"
              @input="toggleMapOnReport"
              :value="jobType.report_with_map">
            {{ Naming.Inspection }} Report - Show Map
          </switch-input>
        </div>
        <div class="column is-6">
          <switch-input
              :description="`Display ${Naming.CustomField.toLowerCase()} meta data for the ${Naming.Asset.toLowerCase()} on the PDF ${Naming.Inspection.toLowerCase()} report.`"
              classes="is-medium"
              @input="toggleAssetMetaFieldsOnInspectionReport"
              :value="jobType.report_with_asset_meta">
            {{ Naming.Inspection }} Report - Show {{ Naming.Asset }} {{ Naming.CustomFields }}
          </switch-input>
        </div>
        <div class="column is-6">
          <switch-input
              :description="`Display ${Naming.CustomField.toLowerCase()} meta data for the ${Naming.Asset.toLowerCase()} on the PDF ${Naming.Job.toLowerCase()} report.`"
              classes="is-medium"
              @input="toggleAssetMetaFieldsOnJobReport"
              :value="jobType.job_report_with_asset_meta">
            {{ Naming.Job }} Report - Show {{ Naming.Asset }} {{ Naming.CustomFields }}
          </switch-input>
        </div>
        <div class="column is-6">
          <switch-input
              :description="`When required, ${Naming.Jobs.toLowerCase()} of this type will require the ${Naming.Technician.toLowerCase()} to only sign once at ${Naming.Job.toLowerCase()} closure which will then automatically apply the signature to all ${Naming.Inspections.toLowerCase()} (Warning: this will replace any previously captured ${Naming.Inspection.toLowerCase()} signatures).`"              classes="is-medium"
              @input="toggleTechnicianSignatureRequirement"
              :value="jobType.requires_technician_signature">
            Requires {{ Naming.Technician }} Signature
          </switch-input>
        </div>
      </div>
      <br/>

      <div class="columns">
        <div class="column">
          <h4 class="is-size-4 has-text-weight-light">{{ Naming.Job }} Closing {{ Naming.CustomFields }}</h4>
          <p class="has-text-cool-blue-text">When closing a {{ Naming.Job.toLowerCase() }} of this type, the fields you add below will be shown to the {{ Naming.Technician.toLowerCase() }} on closing the {{ Naming.Job.toLowerCase() }}, allowing you to store additional information related to the {{ Naming.Job.toLowerCase() }},</p>
          <message class="is-warning mt">{{ Naming.CustomFields }} are considered fixed data points. These values will typically not change over time and are best suited for things like serial numbers etc. Changing these fields will have an effect on reporting</message>
        </div>
      </div>

      <div>
        <new-custom-field/>
        <custom-field
            v-for="(field, index) in jobType.closing_custom_fields"
            :field="field"
            :key="index"/>
      </div>

      <div class="columns">
        <div class="column">
          <submit-button :working="loading" @submit="store" class="is-success is-medium mt-1" left-icon="check">Create
            {{ Naming.JobType }}
          </submit-button>
        </div>
      </div>
      <br/>
    </form>

  </page>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import CustomField from "@/views/job-type/partials/CustomField.vue";
import NewCustomField from "@/views/job-type/partials/NewCustomField.vue";

export default {

  components: {
    CustomField,
    NewCustomField
  },

  data: () => ({
    loading: false
  }),

  beforeDestroy() {
    this.clearJobType()
  },

  methods: {
    ...mapMutations('jobType', [
      'description',
      'clearJobType',
      'passPercentage',
      'toggleActive',
      'toggleSignatureRequirement',
      'toggleSingleInspection',
      'toggleMapOnReport',
      'toggleAssetMetaFieldsOnInspectionReport',
      'toggleAssetMetaFieldsOnJobReport',
      'toggleTechnicianSignatureRequirement'
    ]),
    store() {
      this.loading = true
      this.$store.dispatch('jobType/store').then(jobType => {
        this.$toast.success(this.Convert(this.$lang.jobType.created))
        this.loading = false
        this.$router.back()
      }).catch(error => {
        this.loading = false
        this.$whoops()
      })
    }
  },

  computed: {
    ...mapGetters('jobType', [
      'jobType'
    ])
  }
}
</script>
